import xlsx from 'json-as-xlsx';
import { exportYearBookStudentsPasswordsRequest } from '../services/yearbook';

const profileQuestionsData = [
    {
        sheet: 'Questions',
        columns: [
            { label: 'HEADING', value: 'HEADING' },
            { label: 'QUESTION', value: 'QUESTION' },
            { label: 'TYPE', value: 'TYPE' },
            { label: 'LIMIT', value: 'LIMIT' },
            { label: 'REQUIRED', value: 'REQUIRED' }
        ],
        content: [
            {
                HEADING: 'Best os',
                QUESTION: 'Best os',
                TYPE: 'TEXT_BOX',
                LIMIT: 20,
                REQUIRED: 'Y'
            },
            {
                HEADING: 'Best software',
                QUESTION: 'Best software',
                TYPE: 'TEXT_AREA',
                LIMIT: 20,
                REQUIRED: 'N'
            },
            {
                HEADING: 'Best music player',
                QUESTION: 'Best music player',
                TYPE: 'RADIO_BUTTON',
                LIMIT: 0,
                REQUIRED: 'Y'
            },
            {
                HEADING: 'Best IDE',
                QUESTION: 'Best IDE',
                TYPE: 'DROP_DOWN',
                LIMIT: 0,
                REQUIRED: 'Y'
            },
            {
                HEADING: 'Best Laptop',
                QUESTION: 'Best Laptop',
                TYPE: 'EMAIL',
                LIMIT: 0,
                REQUIRED: 'N'
            },
            {
                HEADING: 'Best Phone',
                QUESTION: 'Best Phone',
                TYPE: 'CALENDAR',
                LIMIT: 0,
                REQUIRED: 'Y'
            }
        ]
    }
];

const pollQuestionsData = [
    {
        sheet: 'Questions',
        columns: [
            { label: 'HEADING', value: 'HEADING' },
            { label: 'QUESTION', value: 'QUESTION' },
            { label: 'TYPE', value: 'TYPE' }
        ],
        content: [
            {
                HEADING: 'Best os',
                QUESTION: 'Best os',
                TYPE: 'MANUAL'
            },
            {
                HEADING: 'Best software',
                QUESTION: 'Best software',
                TYPE: 'STUDENT'
            }
        ]
    }
];

const studentsData = [
    {
        sheet: 'Questions',
        columns: [
            { label: 'NAME', value: 'NAME' },
            { label: 'EMAIL', value: 'EMAIL' },
            { label: 'PHONE', value: 'PHONE' },
            { label: 'ROLE', value: 'ROLE' },
            { label: 'LEVEL', value: 'LEVEL' },
            { label: 'TESTIMONIAL', value: 'TESTIMONIAL' }
        ],
        content: [
            {
                NAME: 'Alex',
                EMAIL: 'alex@gmail.com',
                PHONE: '1234567890',
                ROLE: 1,
                LEVEL: 1,
                TESTIMONIAL: 'Y'
            },
            {
                NAME: 'Gnome',
                EMAIL: 'gnome123@gmail.com',
                PHONE: '1234567890',
                ROLE: 2,
                LEVEL: 3,
                TESTIMONIAL: 'N'
            }
        ]
    }
];

const commonPageData = [
    {
        sheet: 'Folders',
        columns: [{ label: 'TITLE', value: 'TITLE' }],
        content: [{ TITLE: 'Title 1 here' }, { TITLE: 'Title 2 here' }]
    }
];

const settings = {
    fileName: 'sample', // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
};

// eslint-disable-next-line import/prefer-default-export
export const downloadProfileQuestionsSample = () => {
    xlsx(profileQuestionsData, { ...settings, fileName: 'profile-questions-sample' });
};

export const downloadPollQuestionsSample = () => {
    xlsx(pollQuestionsData, { ...settings, fileName: 'poll-questions-sample' });
};

export const downloadStudentsQuestionsSample = () => {
    xlsx(studentsData, { ...settings, fileName: 'students-sample' });
};

export const downloadYearBookStudentsPasswords = async ({ yearBookId }) => {
    const studentsPasswordData = [
        {
            sheet: 'Students',
            columns: [
                { label: 'NAME', value: 'name' },
                { label: 'EMAIL', value: 'email' },
                { label: 'PASSWORD', value: 'password' },
                { label: 'CONTACTNUMBER', value: 'contactNumber' }
            ],
            content: []
        }
    ];
    const result = await exportYearBookStudentsPasswordsRequest({ yearBookId });
    if (result.error === false) {
        const students = result?.students ?? [];
        studentsPasswordData[0].content = students;
    }
    xlsx(studentsPasswordData, { ...settings, fileName: 'students-passwords' });
};

export const downloadCommonPageData = () => {
    xlsx(commonPageData, { ...settings, fileName: 'common-page-data-sample' });
};
